import { Component, OnInit } from '@angular/core';
import { UsuarioSistema } from '../usuario-sistema/usuario-sistema.model';
import { UsuarioSistemaService } from '../usuario-sistema/usuario-sistema.service';
import { LoginService } from './login.service';
import { Router} from '@angular/router';
import notify from 'devextreme/ui/notify';


@Component({
  selector: 'ntc-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  itemsForm = null;
  loginForm = {Login: null, Senha: null};
  usuarioSistema = null;

  constructor(
    private usuarioSistemaService: UsuarioSistemaService,
    private loginService: LoginService,
    private router: Router
  ) { }

  ngOnInit() {
    this.montaForm();
  }

  login(params: any) {
    this.usuarioSistemaService.getUsuarioSistemaByLogin(this.loginForm.Login)
    .subscribe(listaUsuarioSistema => {
      const autenticaLogin = this.loginService.autenticaLogin(listaUsuarioSistema, this.loginForm);
      if (autenticaLogin === true) {
        // logado com sucesso
        notify('Login realizado com sucesso!.', 'success', 2000);
        this.router.navigate(['/']);
      } else {
        // Erro no login
        notify('Login e senha não correspondente.', 'error', 2000);
        this.loginForm = {Login: null, Senha: null};
      }
    },
    error => {
      // Erro de conexao.
      notify('Erro de conexão, favor tentar novamente.', 'error', 2000);
    }
  );
  }

  montaForm() {
    this.itemsForm = [
      {
        dataField: 'Login',
        editorType: 'dxTextBox',
        label: { text: 'Login' },
        editorOptions: {},
        validationRules: [{
          type: 'required',
          message: 'Login é obrigatório.'
        }]
      },
      {
        dataField: 'Senha',
        editorType: 'dxTextBox',
        label: { text: 'Senha' },
        editorOptions: {
          mode: 'password'
        },
        validationRules: [{
          type: 'required',
          message: 'Senha é obrigatória.'
        }]
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts